const getLocalUrl = (file) => {
  // console.log("get local url...");

  if (file instanceof File) {
    return URL.createObjectURL(file);
  }
  return file;
};

const pad = (n) => {
  return n < 10 ? "0" + n : n;
};

const convertFormData = (body) => {
  return new URLSearchParams(body);
};

const validatePhoneNumber = async (_, value) => {
  const phoneNumRegEx = /^0(\d{8}|\d{9})$/;
  if (!phoneNumRegEx.test(value))
    return Promise.reject(
      new Error("กรุณากรอกเบอร์โทรฯ 9 - 10 หลักให้ถูกต้อง")
    );
};

const validateTextOnly = (event) => {
  const keyCode = event.keyCode || event.which;
  if (
    !(keyCode >= 97 && keyCode <= 122) && // a-z
    !(keyCode >= 65 && keyCode <= 90) && // A-Z
    !(keyCode >= 161 && keyCode <= 206) && // ก-ฮ window
    !(keyCode >= 207 && keyCode <= 218) && // สระ
    !(keyCode >= 224 && keyCode <= 238) && // สระ
    // !(keyCode >= 241 && keyCode <= 249) && // ๑-๙
    !(keyCode >= 3585 && keyCode <= 3630) && // ก-ฮ mac
    !(keyCode >= 3631 && keyCode <= 3642) && // สระ
    !(keyCode >= 3648 && keyCode <= 3662) && // สระ
    // !(keyCode >= 3665 && keyCode <= 3673) && // ๑-๙
    keyCode !== 32 // spacebar
  ) {
    event.preventDefault();
  }
};

const validateNumberOnly = (event) => {
  const keyCode = event.keyCode || event.which;
  if (keyCode < 48 || keyCode > 57) {
    event.preventDefault();
  }
};

const validateCitizenId = (_, value) => {
  const match = value.match(/(\d{12})(\d)/);
  if (!match)
    return Promise.reject(
      "กรุณากรอกเลขประจำตัวประชาชน 13 หลักที่เคยลงทะเบียนกับ SCG Family"
    );

  const digits = match[1].split("");
  let sum = 0;
  digits.forEach((d, i) => (sum += (13 - i) * d));
  const checksum = (11 - (sum % 11)) % 10;
  const lastDigit = match[2];
  if (lastDigit !== String(checksum))
    return Promise.reject("กรุณากรอกเลขประจำตัวประชาชน 13 ให้ถูกต้อง");

  return Promise.resolve();
};

const checkValidateCitizen = (_, value) => {
  const match = value.match(/(\d{12})(\d)/);
  if (!match)
    return Promise.reject("กรุณากรอกเลขประจำตัวประชาชน 13 ให้ถูกต้อง");

  const digits = match[1].split("");
  let sum = 0;
  digits.forEach((d, i) => (sum += (13 - i) * d));
  const checksum = (11 - (sum % 11)) % 10;
  const lastDigit = match[2];
  if (lastDigit !== String(checksum))
    return Promise.reject("กรุณากรอกเลขประจำตัวประชาชน 13 ให้ถูกต้อง");

  return Promise.resolve();
};

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  if (!lat1 || !lon1 || !lat2 || !lon2) return 0;

  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
}

const getRedirectPath = (redirect) => {
  let path = "/";
  switch (redirect) {
    case "my_shops":
      path = "/my-shops";
      break;
    case "shops_near_me":
      path = "/shops/near-me";
      break;
    case "my_orders":
      path = "/profile/my-order";
      break;
    case "product_categories":
      path = "/product-categories";
      break;
  }

  return path;
};

const beep = () => {
  var snd = new Audio(
    "data:audio/wav;base64,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"
  );
  snd.play();
};

const getDifferenceInDays = (date1, date2) => {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60 * 60 * 24);
};

const getDifferenceInHours = (date1, date2) => {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60 * 60);
};

const getDifferenceInMinutes = (date1, date2) => {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60);
};

const getDifferenceInSeconds = (date1, date2) => {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / 1000;
};

const getDistanceShops = (shops, resultDistanceService, settings, type) => {
  // console.log("getDistanceShops check shops =>", shops);
  // console.log("getDistanceShops check google =>", resultDistanceService);
  // console.log("getDistanceShops check settings =>", settings);

  const distances = resultDistanceService?.rows[0]?.elements.map(
    (x) => x.distance.value / 1000
  );

  let i = 0;
  // const shopDistances = []
  for (let i = 0; i < shops.length; i++) {
    const shop = shops[i];
    shop.distance = distances[i];
  }

  // console.log("getDistanceShops distances =>", distances);

  // sort
  sort(shops, "distance");

  // filter in radius
  if (type === "nearme") {
    if (settings && settings.shopDistance) {
      const newShops = [];
      for (let i = 0; i < shops.length; i++) {
        const shop = shops[i];
        if (shop.distance <= settings.shopDistance) {
          newShops.push(shop);
        }
      }
      shops = newShops;
    }
  }

  // console.log("getDistanceShops check shops after =>", shops);

  return shops;
};

const sort = (array, field, orderBy = "asc") => {
  const compare = (a, b) => {
    if (a[field] < b[field]) {
      return orderBy === 1 || orderBy === "asc" ? -1 : 1;
    }
    if (a[field] > b[field]) {
      return orderBy === 1 || orderBy === "asc" ? 1 : -1;
    }
    return 0;
  };

  array.sort(compare);
};

const getArrayByRanges = ({ array = [], limit = 0 }) => {
  const arraySelected = [];
  const rounds = Math.ceil(array.length / limit);
  // console.log("rounds =>", rounds);
  // console.log("limit =>", limit);

  for (let i = 0; i < rounds; i++) {
    // console.log("i =>", i);
    const start = i * limit;
    const iEnd = i == 0 ? 1 : i + 1;
    // console.log("iEnd =>", iEnd);
    const end =
      i < rounds - 1
        ? iEnd * limit
        : array.length -
          Math.floor(array.length / limit) * limit +
          Math.floor(array.length / limit) * limit;

    const selected = array.slice(start, end);

    // console.log(`index: ${i}, start =>`, start);
    // console.log(`index: ${i}, end =>`, end);
    // console.log(`index: ${i}, selected =>`, selected);
    arraySelected.push(selected);
  }
  return arraySelected;
};

export {
  getLocalUrl,
  pad,
  convertFormData,
  validatePhoneNumber,
  validateNumberOnly,
  validateCitizenId,
  validateTextOnly,
  getDistanceFromLatLonInKm,
  getRedirectPath,
  beep,
  getDifferenceInDays,
  getDifferenceInHours,
  getDifferenceInMinutes,
  getDifferenceInSeconds,
  getDistanceShops,
  sort,
  getArrayByRanges,
  checkValidateCitizen,
};
